"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsMain = void 0;
var react_1 = __importDefault(require("react"));
var uuid_1 = require("uuid");
var mappings_1 = require("../../../../shared/api/mappings");
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var components_1 = require("../../components");
var PageLoading_1 = require("../../components/PageLoading");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
var ui_1 = require("./ui");
var getChildKey = function (key) { return (key ? key : (0, uuid_1.v4)()); };
var MeterReadingsWithData = function (_a) {
    var supplies = _a.supplies;
    var _b = (0, core_1.useComponents)(), Card = _b.Card, Heading1 = _b.Heading1, Stack = _b.Stack;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    if ((0, utils_1.hasNoActiveSupplies)(supplies)) {
        return react_1.default.createElement(ui_1.NoActiveSupplies, null);
    }
    return (react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Heading1, null,
                react_1.default.createElement(Copy, { copyKey: "summaryHeading" })),
            react_1.default.createElement(Copy, { copyKey: "summaryHeadingText" })),
        supplies.electricity.map(function (supply, index) { return (react_1.default.createElement(components_1.PopulatedMeterSummary, { key: getChildKey(supply.msn), supply: supply, supplyIndex: index, supplyCount: supplies.electricity.length })); }),
        supplies.gas.map(function (supply, index) { return (react_1.default.createElement(components_1.PopulatedMeterSummary, { key: getChildKey(supply.msn), supply: supply, supplyIndex: index, supplyCount: supplies.gas.length })); })));
};
exports.MeterReadingsMain = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var accountId = _a.accountId;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _c = (0, mappings_1.useMeterReads)(accountId), data = _c.data, loading = _c.loading, error = _c.error;
    if (loading) {
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    }
    if (error) {
        return react_1.default.createElement(components_1.Error, null);
    }
    if (!data) {
        return (react_1.default.createElement(components_1.NoDataError, { heading: react_1.default.createElement(Copy, { copyKey: "meterReadsHeading" }), "data-testid": 'kapi-meter-reads-info-error' }));
    }
    return (react_1.default.createElement(ui_1.MeterReadingsPage, { name: analytics_subjects_1.METER_READINGS_SUMMARY, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b[analytics_subjects_1.KAPI_ONLY] = true, _b), supplies: data },
        react_1.default.createElement(MeterReadingsWithData, { supplies: data })));
});
